<template>
	<nav class="nav">
		<div class="nav__desktop">
			<div class="container">
				<div class="row">
					<div class="col-2">
						<div class="nav__wrapper">
							<router-link :to="{name: 'Home'}" class="nav__logo" href="#"><img @click="openMenu = false" src="/static/img/logo.png" alt=""></router-link>
						</div>
					</div>
					<div class="col-6">
						<div class="nav__wrapper">
							<ul class="nav__list nav__list--main">
								<li @click="openMenu = !openMenu, openTab = 'events'"><a href="#">{{ $t("nav.events") }}</a></li>
								<li v-if="$store.state.user.isLogged" @click="openMenu = false"><router-link :to="{name: 'MyEventsList'}" class="nav__my-events">{{ $t("nav.myEvents") }}<img class="nav__star" src="/static/img/star.png" alt=""></router-link></li>
								<li v-if="!$store.state.user.isLogged" @click="openMenu = false"><router-link :to="{name: 'CreateAccount'}" class="nav__my-events">{{ $t("nav.myEvents") }}<img class="nav__star" src="/static/img/star.png" alt=""></router-link></li>
								<li @click="openMenu = false"><router-link :to="{name: 'JudgesList'}">{{ $t("nav.judges") }}</router-link></li>
							</ul>
						</div>
					</div>

					<div class="col-1"></div>

					<div class="col-3">
						<div class="nav__wrapper nav__wrapper--end">
							<ul class="nav__list nav__list--user">
								<li v-if="$store.state.user.isLogged"><router-link :to="{name: 'Account'}">{{ $t("nav.myAccount") }}</router-link></li>
								<li v-if="!$store.state.user.isLogged"><a @click="$emit('changeShow', true), openMenu = false">{{ $t("nav.logIn") }}</a></li>
								<li v-if="$store.state.user.isLogged"><a @click="$store.commit('userLogOut'), openMenu = false">{{ $t("nav.logOut") }}</a></li>
								<li @click="openMenu = !openMenu, openTab = 'flags'">
									<a href="#">
										<img v-if="lang === 'pl'" class="nav__flag" src="/static/img/pl.png" alt="">
										<img v-if="lang === 'en'" class="nav__flag" src="/static/img/en.png" alt="">
										<img v-if="lang === 'de'" class="nav__flag" src="/static/img/de.png" alt="">
										<img v-if="lang === 'ru'" class="nav__flag" src="/static/img/ru.png" alt="">
										<img v-if="lang === 'sp'" class="nav__flag" src="/static/img/sp.png" alt="">
										<img v-if="lang === 'fr'" class="nav__flag" src="/static/img/fr.png" alt="">
										<img v-if="lang === 'it'" class="nav__flag" src="/static/img/it.png" alt="">
										<img v-if="lang === 'hu'" class="nav__flag" src="/static/img/hu.png" alt="">
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="nav__mobile">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">

						<div class="nav__wrapper">
							<router-link :to="{name: 'Home'}" class="nav__logo" href="#"><img @click="openMenu = false, openMobileMenu = false, toggled = false" src="/static/img/logo.png" alt=""></router-link>

							<div class="nav__wrapper nav__wrapper--end">
								<ul class="nav__list nav__list--user">
									<li v-if="!$store.state.user.isLogged"><a @click="$emit('changeShow', true), openMenu = false, openMobileMenu = false, toggled = false">{{ $t("nav.logIn") }}</a></li>
									<li v-if="$store.state.user.isLogged"><a @click="$store.commit('userLogOut'), openMenu = false, openMobileMenu = false, toggled = false">{{ $t("nav.logOut") }}</a></li>
									<li>
										<button class="hamburger" @click="toggled = !toggled, openMobileMenu = !openMobileMenu">
											<div class="hamburger__lines">
												<span :class="{'hamburger__line--closed': toggled}" class="hamburger__line"></span>
												<span :class="{'hamburger__line--closed': toggled}" class="hamburger__line"></span>
												<span :class="{'hamburger__line--closed': toggled}" class="hamburger__line"></span>
											</div>
										</button>
									</li>
								</ul>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div v-if="openMenu" class="nav-open">
			<div class="container">
				<div class="row">
					<div class="col-2">
					</div>
					<div class="col-2">
						<ul v-if="openTab === 'events'" class="nav-open__events">
							<li @click="openMenu = !openMenu"><a @click="directTo()">{{ $t("nav.ranks.all") }}</a></li>
							<li @click="openMenu = !openMenu"><a @click="directTo('national')">{{ $t("events.rank.national") }}</a></li>
							<li @click="openMenu = !openMenu"><a @click="directTo('international')">{{ $t("events.rank.international") }}</a></li>
							<li @click="openMenu = !openMenu"><a @click="directTo('club')">{{ $t("events.rank.club") }}</a></li>
						</ul>
					</div>

					<div class="col-7"></div>

					<div class="col-1">
						<ul v-if="openTab === 'flags'" class="nav-open__flags">
							<li v-if="lang !== 'pl'" @click="openMenu = !openMenu, lang = 'pl', setLang('pl')"><a href="#"><img class="nav-open__flag" src="/static/img/pl.png" alt=""></a></li>
							<li v-if="lang !== 'en'" @click="openMenu = !openMenu, lang = 'en', setLang('en')"><a href="#"><img class="nav-open__flag" src="/static/img/en.png" alt=""></a></li>
							<li v-if="lang !== 'de'" @click="openMenu = !openMenu, lang = 'de', setLang('de')"><a href="#"><img class="nav-open__flag" src="/static/img/de.png" alt=""></a></li>
							<li v-if="lang !== 'ru'" @click="openMenu = !openMenu, lang = 'ru', setLang('ru')"><a href="#"><img class="nav-open__flag" src="/static/img/ru.png" alt=""></a></li>
							<li v-if="lang !== 'sp'" @click="openMenu = !openMenu, lang = 'sp', setLang('sp')"><a href="#"><img class="nav-open__flag" src="/static/img/sp.png" alt=""></a></li>
							<li v-if="lang !== 'fr'" @click="openMenu = !openMenu, lang = 'fr', setLang('fr')"><a href="#"><img class="nav-open__flag" src="/static/img/fr.png" alt=""></a></li>
							<li v-if="lang !== 'it'" @click="openMenu = !openMenu, lang = 'it', setLang('it')"><a href="#"><img class="nav-open__flag" src="/static/img/it.png" alt=""></a></li>
							<li v-if="lang !== 'hu'" @click="openMenu = !openMenu, lang = 'hu', setLang('hu')"><a href="#"><img class="nav-open__flag" src="/static/img/hu.png" alt=""></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div v-if="openMobileMenu" class="nav-open nav-open--mobile">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<ul class="nav__list nav__list--mobile-account">
							<li v-if="!$store.state.user.isLogged" @click="openMobileMenu = false, toggled = !toggled"><router-link :to="{name: 'CreateAccount'}">{{ $t("nav.createAccount") }}</router-link></li>
							<li v-if="$store.state.user.isLogged" @click="openMobileMenu = false, toggled = !toggled"><router-link :to="{name: 'Account'}">{{ $t("nav.myAccount") }}</router-link></li>
						</ul>
					</div>
				</div>
				<div class="row">
					<div class="col-md-5 col-sm-12">
						<div class="nav__wrapper">
							<ul class="nav__list nav__list--main">
								<li @click="openTab = 'events'"><a href="#">{{ $t("nav.events") }}</a></li>
								<li v-if="$store.state.user.isLogged" @click="openMobileMenu = false, toggled = !toggled"><router-link :to="{name: 'MyEventsList'}" class="nav__my-events">{{ $t("nav.myEvents") }}<img class="nav__star" src="/static/img/star.png" alt=""></router-link></li>
								<li v-if="!$store.state.user.isLogged" @click="openMobileMenu = false, toggled = !toggled"><router-link :to="{name: 'CreateAccount'}" class="nav__my-events">{{ $t("nav.myEvents") }}<img class="nav__star" src="/static/img/star.png" alt=""></router-link></li>
								<li @click="openMobileMenu = false, toggled = !toggled"><router-link :to="{name: 'JudgesList'}">{{ $t("nav.judges") }}</router-link></li>
								<li @click="openTab = 'flags'">
									<a href="#">
										<img v-if="lang === 'pl'" class="nav__flag" src="/static/img/pl.png" alt="">
										<img v-if="lang === 'en'" class="nav__flag" src="/static/img/en.png" alt="">
										<img v-if="lang === 'de'" class="nav__flag" src="/static/img/de.png" alt="">
										<img v-if="lang === 'ru'" class="nav__flag" src="/static/img/ru.png" alt="">
										<img v-if="lang === 'sp'" class="nav__flag" src="/static/img/sp.png" alt="">
										<img v-if="lang === 'fr'" class="nav__flag" src="/static/img/fr.png" alt="">
										<img v-if="lang === 'it'" class="nav__flag" src="/static/img/it.png" alt="">
										<img v-if="lang === 'hu'" class="nav__flag" src="/static/img/hu.png" alt="">
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4 col-sm-6">
						<ul v-if="openTab === 'events'" class="nav-open__events">
							<li @click="openMobileMenu = !openMobileMenu, toggled = !toggled, openTab = ''"><a @click="directTo()">{{ $t("nav.ranks.all") }}</a></li>
							<li @click="openMobileMenu = !openMobileMenu, toggled = !toggled, openTab = ''"><a @click="directTo('national')">{{ $t("events.rank.national") }}</a></li>
							<li @click="openMobileMenu = !openMobileMenu, toggled = !toggled, openTab = ''"><a @click="directTo('international')">{{ $t("events.rank.international") }}</a></li>
							<li @click="openMobileMenu = !openMobileMenu, toggled = !toggled, openTab = ''"><a @click="directTo('club')">{{ $t("events.rank.club") }}</a></li>
						</ul>
					</div>

					<div class="col-md-1 col-sm-6">
						<ul v-if="openTab === 'flags'" class="nav-open__flags">
							<li v-if="lang !== 'pl'" @click="openMobileMenu = !openMobileMenu, lang = 'pl', toggled = !toggled, openTab = '', setLang('pl')"><a href="#"><img class="nav-open__flag" src="/static/img/pl.png" alt=""></a></li>
							<li v-if="lang !== 'en'" @click="openMobileMenu = !openMobileMenu, lang = 'en', toggled = !toggled, openTab = '', setLang('en')"><a href="#"><img class="nav-open__flag" src="/static/img/en.png" alt=""></a></li>
							<li v-if="lang !== 'de'" @click="openMobileMenu = !openMobileMenu, lang = 'de', toggled = !toggled, openTab = '', setLang('de')"><a href="#"><img class="nav-open__flag" src="/static/img/de.png" alt=""></a></li>
							<li v-if="lang !== 'ru'" @click="openMobileMenu = !openMobileMenu, lang = 'ru', toggled = !toggled, openTab = '', setLang('ru')"><a href="#"><img class="nav-open__flag" src="/static/img/ru.png" alt=""></a></li>
							<li v-if="lang !== 'sp'" @click="openMobileMenu = !openMobileMenu, lang = 'sp', toggled = !toggled, openTab = '', setLang('sp')"><a href="#"><img class="nav-open__flag" src="/static/img/sp.png" alt=""></a></li>
							<li v-if="lang !== 'fr'" @click="openMobileMenu = !openMobileMenu, lang = 'fr', toggled = !toggled, openTab = '', setLang('fr')"><a href="#"><img class="nav-open__flag" src="/static/img/fr.png" alt=""></a></li>
							<li v-if="lang !== 'it'" @click="openMobileMenu = !openMobileMenu, lang = 'fr', toggled = !toggled, openTab = '', setLang('it')"><a href="#"><img class="nav-open__flag" src="/static/img/it.png" alt=""></a></li>
							<li v-if="lang !== 'hu'" @click="openMobileMenu = !openMobileMenu, lang = 'hu', toggled = !toggled, openTab = '', setLang('hu')"><a href="#"><img class="nav-open__flag" src="/static/img/hu.png" alt=""></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
	export default {
		data () {
			return {
				show: false,
				openMenu: false,
				openTab: '',
				lang: 'en',
				toggled: false,
				openMobileMenu: false
			}
		},
		methods: {
			changeShow () {
				this.$emit('changeShow', 'true')
			},
			closeMenu (e) {
				if (this.openMenu && !e.target.matches('.nav-open, .nav-open *') && !e.target.matches('.nav__wrapper, .nav__wrapper *')) {
					this.openMenu = false
				}
				if (this.openMobileMenu && !e.target.matches('.nav-open, .nav-open *') && !e.target.matches('.nav__wrapper, .nav__wrapper *')) {
					this.openMobileMenu = false
					this.toggled = false
				}
			},
			directTo (rank) {
				this.$store.commit('clearEventsFilters')
				this.$router.push({name: 'EventsList', query: { rank }})
			},
			setLang (lang) {
				localStorage.setItem('lang', lang)
				this.$i18n.locale = localStorage.lang
				location.reload()
			}
		},
		created () {
			document.addEventListener('click', this.closeMenu)
			this.lang = localStorage.lang
		}
	}
</script>

<style lang="scss" scoped>
	@import "../styles/variables.scss";

	.nav {
		&__desktop {
			display: none;
			@media (min-width: 992px) {
				display: block;
			}
		}
		&__mobile {
			display: none;
			@media (max-width: 991px) {
				display: block;
			}
		}
		&__wrapper {
			height: 60px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			&--end {
				justify-content: flex-end;
			}
		}
		&__list {
			display: flex;
			align-items: center;
			padding: 0;
			li {
				list-style: none;
				font-size: 13px;
				a {
					text-decoration: none;
					color: $black;
					text-transform: uppercase;
					cursor: pointer;
				}
			}
			&--main {
				li {
					margin-right: 20px;
				}
			}
			&--user {
				justify-content: flex-end;
				li {
					margin-left: 20px;
				}
			}
			&--mobile-account {
				margin: 0;
			}
		}

		&__my-events {
			position: relative;
			padding-right: 20px;
		}
		&__star {
			position: absolute;
			right: 0;
			top: 45%;
			transform: translateY(-50%);
			width: 15px;
			height: 15px;
		}
		&__flag {
			width: 25px;
			height: 15px;
		}
		&__logo {
			margin-right: 70px;
		}
	}

	.nav-open {
		position: absolute;
		width: 100%;
		z-index: 9;
		padding: 20px 0 10px;
		background-color: rgba(245, 238, 223, .93);
		&--mobile {
			display: none;
			@media (max-width: 991px) {
				display: block;
			}
		}
		&__events {
			list-style: none;
			margin: 0;
			li {
				text-align: left;
				margin-bottom: 20px;
				font-size: 13px;
				a {
					display: block;
					text-decoration: none;
					color: $black;
					text-transform: uppercase;
					cursor: pointer;
				}
			}
		}
		&__flags {
			list-style: none;
			margin: 0;
			li {
				text-align: right;
				margin-bottom: 10px;
				font-size: 13px;
				a {
					display: block;
					text-decoration: none;
					color: $black;
					text-transform: uppercase;
					cursor: pointer;
				}
			}
		}
		&__flag {
			width: 25px;
			height: 15px;
		}
	}

	.hamburger {
		-webkit-tap-highlight-color: rgba(0,0,0,0);
		color: $black;
		border: 0;
		background: 0;
		padding: 0;
		z-index: 9;
		cursor: pointer;
		&:focus {
			outline: none;
		}
		&__lines {
			position: relative;
			margin: 0 auto;
		}
		&__line {
			display: block;
			background: $black;
			width: 25px;
			height: 3px;
			transition: all .3s;
			margin-bottom: 5px;
			&:last-child {
				margin-bottom: 0;
			}
			&--closed {
				&:nth-child(1) {
					transform-origin: 100%;
					transform: rotate(-45deg) translate(1px);
				}
				&:nth-child(2) {
					visibility: hidden;
					opacity: 0;
				}
				&:nth-child(3) {
					transform-origin: 100%;
					transform: rotate(45deg) translate(1px);
				}
			}
		}
	}

	@media (max-width: 575.98px) {
		.nav {
			&__wrapper {
				justify-content: space-between;
			}
			&__logo {
				margin-right: 0;
			}
			&__list {
				width: 100%;
				justify-content: space-between;
				&--main {
					li {
						margin-right: 0;
					}
				}
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {
		.nav {
			&__wrapper {
				justify-content: space-between;
			}
			&__logo {
				margin-right: 0;
			}
			&__list {
				width: 100%;
				justify-content: space-between;
				&--main {
					li {
						margin-right: 0;
					}
				}
			}
		}
	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {
		.nav {
			&__wrapper {
				justify-content: space-between;
			}
			&__logo {
				margin-right: 0;
			}
			&__list {
				width: 100%;
				justify-content: space-between;
				&--main {
					li {
						margin-right: 0;
					}
				}
			}
		}
	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}

</style>



// WEBPACK FOOTER //
// src/components/NavComponent.vue